import { makeActionCreator } from '../../config/store/utils'
import { getContingencyOptions } from '../../services/contingencies'

export const GET_CONTINGENCY_OPTIONS = 'GET_CONTINGENCY_OPTIONS'
export const GET_CONTINGENCY_OPTIONS_ERROR = 'GET_CONTINGENCY_OPTIONS_ERROR'
export const GET_CONTINGENCY_OPTIONS_SUCCESS = 'GET_CONTINGENCY_OPTIONS_SUCCESS'
export const onGetContingencyOptions = makeActionCreator(GET_CONTINGENCY_OPTIONS)
export const onGetContingencyOptionsError = makeActionCreator(GET_CONTINGENCY_OPTIONS_ERROR, 'payload')
export const onGetContingencyOptionsSuccess = makeActionCreator(GET_CONTINGENCY_OPTIONS_SUCCESS, 'payload')
export const onGetContingencyOptionsThunk = () => async dispatch => {
  dispatch(onGetContingencyOptions())

  try {
    const { data = {} } = await getContingencyOptions()
    const options = data?.payload?.map(option => ({
      name: option.name,
      value: option.id,
      startYear: option.startYear,
      endYear: option.endYear
    }))

    return dispatch(onGetContingencyOptionsSuccess({ options }))
  } catch (error) {
    return dispatch(onGetContingencyOptionsError({ error }))
  }
}
